import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {  close } from "../../../modules/modals";
import AcknowledgementLayout from "../../../Components/BindingPharmacy/common/acknowledgement";

const mapStateToProps = state => {
  const {
      lang
  } = state;

  return {
      lang
  };
};

const mapDispatchToProps = dispatch => {
  return {
    close: () => dispatch(close())
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(AcknowledgementLayout)
);
